import { Badge } from '@/components/ui/badge';

interface RouteItemProps {
  route: {
    from: { name: string };
    to: { name: string };
    value: number;
    type: string;
  };
  formatNumber: (num: number) => string;
}

export function RouteItem({ route, formatNumber }: RouteItemProps) {
  return (
    <div className="p-3 border rounded-lg">
      <div className="flex items-center justify-between mb-2">
        <div className="font-medium">
          {route.from.name} → {route.to.name}
        </div>
        <Badge variant="secondary" className="capitalize">
          {route.type}
        </Badge>
      </div>
      <div className="grid grid-cols-2 gap-4 text-sm text-muted-foreground">
        <div>
          <span className="font-medium">Volume:</span> {formatNumber(route.value)} mt
        </div>
        <div>
          <span className="font-medium">Mode:</span> {route.type}
        </div>
      </div>
    </div>
  );
}
